import React, { useContext, useEffect } from 'react'; //eslint-disable-line
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import locationStoreContext from '../stores/locationStore';
import viewStoreContext from '../stores/viewStore';
import * as CONSTS from '../utils/constants';
import '../i18n';
import StationDepartureRows from '../components/StationDepartureRows';

const DirectionDepartures = observer(props => {
  const locationStore = useContext(locationStoreContext);
  const viewStore = useContext(viewStoreContext);
  const { t } = useTranslation();
  const serviceDirection = viewStore.serviceDirection;
  // Display the first direction as default if service direction is not selected
  let directions = locationStore.messages.directions.filter((d, i) => i === 0);

  if (serviceDirection) {
    directions = locationStore.messages.directions.filter(d => d.direction === serviceDirection);
  }

  //Set default service direction
  viewStore.setServiceDirection(directions[0].direction);

  const handleMoreTrips = (direction, totalTrips) => {
    if (viewStore.inboundTripsDisplayed < totalTrips || viewStore.outboundTripsDisplayed < totalTrips) {
      viewStore.incrementTripRowLimit(direction);
    }
  };

  const getMoreTrips = (totalTrips = 0, direction = '') => {
    let moreTripNumber = 0;

    if (direction === CONSTS.SERVICE_DIRECTION_INBOUND) {
      moreTripNumber = totalTrips - viewStore.inboundTripsDisplayed;
    } else if (direction === CONSTS.SERVICE_DIRECTION_OUTBOUND) {
      moreTripNumber = totalTrips - viewStore.outboundTripsDisplayed;
    }

    if (moreTripNumber < 0) {
      moreTripNumber = 0;
    }

    return moreTripNumber < 1 ? 0 : moreTripNumber;
  };

  const getPath = (trip, delayTime) => {
    return {
      pathname: `${viewStore.views.stationDeparture}/${props.corridor}/${props.station}/${viewStore.views.tripDetail}/${trip.tripName}`,
      state: {
        direction: trip.direction,
        isLoaded: true,
        delayTime: delayTime,
        isExpress: trip.isExpress,
        coachCount: trip.coachCount,
        scheduledCoachCount: trip.scheduledCoachCount
      }
    };
  };

  const maxTripsDisplayed = serviceDirection === CONSTS.SERVICE_DIRECTION_INBOUND ? viewStore.inboundTripsDisplayed : viewStore.outboundTripsDisplayed;

  return (
    <React.Fragment>
      {directions.map((trip, index) => {
        const moreTripNumber = getMoreTrips(trip.tripMessages.length, trip.direction);
        return (
          <React.Fragment key={`${trip.direction}-${index}`}>
            <StationDepartureRows
              serviceDirection={viewStore.serviceDirection}
              languageName={viewStore.languageName}
              trips={trip}
              onGetPath={getPath}
              onResetTripDetail={locationStore.resetTripDetail}
              isTwentyFourHour={viewStore.isTwentyFourHour}
              maxTripsDisplayed={maxTripsDisplayed}
            />
            {moreTripNumber > 0 && (
              <div className="departure-row button">
                <button onClick={() => handleMoreTrips(trip.direction, trip.tripMessages.length)} className="button all-trips">
                  {`${t('seeMoreTrips')} (${moreTripNumber})`}
                </button>
              </div>
            )}
          </React.Fragment>
        );
      })
      }
    </React.Fragment>
  );
});

export default DirectionDepartures;
